export const addToRecord: <T, R extends T>(
  record: Record<string, T>,
  id: string,
  newValue: R
) => Record<string, T | R> = (state, id, newValue) => ({
  ...state,
  [id]: newValue,
});
